import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { HotTable } from '@handsontable/react';
import * as ProjectActionCreators from '../../ducks/projects';

class ProjectImporterModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tableContent: [[]],
            importing: false,
            justImported: false,
            show: false,
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ show: props.show });
    }

    toggle = () => {
        let hiding = this.state.show;
        this.setState({ show: !this.state.show });

        if(hiding && typeof this.props.onHide === 'function')
            this.props.onHide();
    }

    handleTableChange = (event, source) => {
        if(!event) {
            return;
        }

        let tableContent = this.state.tableContent;

        event.map((change) => {
            let i = change[0];
            let j = change[1];

            if(!tableContent[i]) {
                tableContent[i] = [];
            }

            tableContent[i][j] = change[3];

            return null;
        });

        this.setState({ tableContent: tableContent });
    }

    structureProjectObjects = (tableContent) => {
        return tableContent.map((row) => {
            return {
                fy: this.currentFy(),
                project_name: row[0],
                asset_name: row[1],
                space_name: row[2],
                subspace_name: row[3],
                sub_subspace_name: row[4],
                proceeds_spent: row[5],
                equity_spent: row[6],
                original_bond_issue: row[7],
                in_service_date: row[8],
            };
        });
    }

    currentFy = () => {
        return this.props.puCalcFy && this.props.puCalcFy !== 'latest' ? this.props.puCalcFy : this.props.client.pu_fys[0];
    }

    hasProjectsInTable = () => {
        return this.state.tableContent.length > 0 && this.state.tableContent[0].length > 0;
    }

    importProjects = () => {
        if(this.hasProjectsInTable() && !this.state.importing) {
            this.setState({ importing: true });

            this.props
                .importProjects({
                    client_id: this.props.client.client_id,
                    project_benefits: this.structureProjectObjects(this.state.tableContent),
                    inputData: this.state.tableContent,
                })
                .then(() => {
                    this.setState({ importing: false, justImported: true });
                    this.toggle();
                    if (typeof this.props.onHide === 'function') {
                        this.props.onHide();
                    }
                })
                .catch((error) => {
                    this.setState({ importing: false });
                    alert(error);
                });
        }
    }

    clearForm = () => {
        this.setState({
            tableContent: [[]],
            importing: false,
            justImported: false,
        });
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={this.toggle} className="modal-xl" backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <span className="font-weight-bold">Import Projects</span>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div style={{height: '550px', overflowY: 'hidden'}}>
                                <HotTable
                                    root={ "hotImportUses" }
                                    data={ this.state.tableContent }
                                    contextMenu={true}
                                    columns={[
                                        { type: 'text', width: 120 },
                                        { type: 'text', width: 120 },
                                        { type: 'text', width: 120 },
                                        { type: 'text', width: 120 },
                                        { type: 'text', width: 120 },
                                        { type: 'numeric', numericFormat: { pattern: '0,0.00' }, correctFormat: true, className: "htRight" },
                                        { type: 'numeric', numericFormat: { pattern: '0,0.00' }, correctFormat: true, className: "htRight" },
                                        { type: 'text', width: 115 },
                                        { 
                                            type: 'text',
                                            className: "htRight",
                                            width: 105
                                        },
                                    ]}
                                    colHeaders={[
                                        'Project Name',
                                        'Asset Name or Code',
                                        'Space (opt.)',
                                        'Subspace (opt.)',
                                        'Sub-subspace (opt.)',
                                        'FY' + this.currentFy() + ' Proceeds Spent',
                                        'FY' + this.currentFy() + ' Equity Spent',
                                        'Original Bond Issue',
                                        'Placed In Service',
                                    ]}
                                    rowHeaders={ true }
                                    minRows={ 20 }
                                    //afterPaste={ (event, source) => { console.log('paste', event, source); } }
                                    afterChange={this.handleTableChange} />
                            </div>
                        </div>
                    </div>
                    <div className="text-right">
                        {
                            this.hasProjectsInTable()
                                ? (<button className="btn btn-success rounded-0" onClick={this.importProjects}>
                                    {
                                        this.state.importing
                                            ? 'Importing...'
                                            : 'Import Projects'
                                    }
                                </button>)
                                : '' 
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

ProjectImporterModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
};

const mapStateToProps = state => (
    {
        client: state.client.client,
        puCalcFy: state.client.puCalcFy,
    }
);

const mapDispatchToProps = dispatch => {
    return {
        importProjects: (importData) => dispatch(ProjectActionCreators.importStructured(importData)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectImporterModal);